module.exports = __webpack_public_path__ + "img/Primordial-Process-9-mobile.30a9ca1a.png";